import { render } from "./SecurityCenter.vue?vue&type=template&id=b86a14d0&scoped=true"
import script from "./SecurityCenter.vue?vue&type=script&lang=js"
export * from "./SecurityCenter.vue?vue&type=script&lang=js"

import "./SecurityCenter.vue?vue&type=style&index=0&id=b86a14d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b86a14d0"]])

export default __exports__